import '../../shared/js/utils/polyfills';
import { initGiftCarousels } from './sections/gifts/gifts-carousel';
import { initSimilarProductsCarousel } from './sections/product/product-carousel';
import { initToggleVoucherInfo } from './sections/cart/voucher-info';

document.addEventListener('DOMContentLoaded', () => {
    initToggleVoucherInfo();

    initSimilarProductsCarousel();

    initGiftCarousels();

    naja.snippetHandler.addEventListener('afterUpdate', (event) => {
        initGiftCarousels('#' + event.detail.snippet.id);
    });
});
